// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59835a2a","453":"520d1391","455":"4cb8283a","977":"0e5aeadf"}[chunkId] + ".chunk.js";
};